import { c as _c } from "react/compiler-runtime";
import { Button } from '@chakra-ui/react';
import { useAdvisorsAttention } from '@src/components/sco/Advisors/hooks/useAdvisorsAttention';
import { advisorsBreadcrumbsWithTrail, useAdvisorsToolbar } from '@src/components/sco/Advisors/hooks/useAdvisorsToolbar';
import { useBoardSeatCounts } from '@src/components/sco/Advisors/hooks/useBoardSeatCounts';
import { AdvisorsSubNavLayout } from '@src/components/sco/Advisors/layout/AdvisorsSubNavLayout';
import { useAdvisorsPaths } from '@src/components/sco/Advisors/paths';
import { seatsNavItems, SeatsSectionKey } from '@src/components/sco/Advisors/utils/seatsNav';
import { NextLink } from '@src/components/sco/utilities/NextLink';
import { ReactNode } from 'react';
import { LuPlus } from 'react-icons/lu';

/**
 * My Advisors shell — status sub-nav rail plus section content.
 * "Add a board seat" sits in the rail footer so it is reachable from any view.
 *
 * Searching shows unreviewed applications (your turn, W3) in place of its seat inventory when there
 * are any. Every other count is local inventory and never climbs to My Advisors.
 */
export const BoardSeatsLayout = t0 => {
  const $ = _c(17);
  const {
    activeKey,
    title,
    description,
    action,
    children
  } = t0;
  const paths = useAdvisorsPaths();
  const {
    counts
  } = useBoardSeatCounts();
  const {
    attention
  } = useAdvisorsAttention();
  const navItems = seatsNavItems(paths);
  let t1;
  if ($[0] !== activeKey) {
    t1 = item => item.key === activeKey;
    $[0] = activeKey;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const activeItem = navItems.find(t1);
  useAdvisorsToolbar({
    breadcrumbs: activeKey === "board" ? advisorsBreadcrumbsWithTrail({
      title: "My Advisors",
      href: paths.myAdvisors
    }) : advisorsBreadcrumbsWithTrail({
      title: "My Advisors",
      href: paths.myAdvisors
    }, {
      title: activeItem?.title ?? "My Advisors",
      href: activeItem?.href ?? paths.myAdvisors
    })
  });
  const T0 = AdvisorsSubNavLayout;
  const t2 = "Everyone you own \u2014 on the board, invited, searching, or still a draft.";
  const t3 = "My Advisors";
  let t4;
  if ($[2] !== attention || $[3] !== counts) {
    t4 = item_0 => ({
      key: item_0.key,
      title: item_0.title,
      href: item_0.href,
      icon: item_0.icon,
      count: counts[item_0.countKey],
      attentionCount: item_0.key === "searching" ? attention.unreviewedApplications : undefined
    });
    $[2] = attention;
    $[3] = counts;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const t5 = navItems.map(t4);
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <LuPlus />;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== paths.seatNew) {
    t7 = <Button asChild={true} size="sm" variant="cta" width="full"><NextLink href={paths.seatNew}>{t6} Add a board seat</NextLink></Button>;
    $[6] = paths.seatNew;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== T0 || $[9] !== action || $[10] !== activeKey || $[11] !== children || $[12] !== description || $[13] !== t5 || $[14] !== t7 || $[15] !== title) {
    t8 = <T0 action={action} activeKey={activeKey} description={description} railDescription={t2} railTitle={t3} title={title} items={t5} railFooter={t7}>{children}</T0>;
    $[8] = T0;
    $[9] = action;
    $[10] = activeKey;
    $[11] = children;
    $[12] = description;
    $[13] = t5;
    $[14] = t7;
    $[15] = title;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  return t8;
};